<template>
    <div class="profile">
        <el-row>
            <el-col :offset="8" :span="8">
                <!--                <div>-->
                <!--                    <h5 class="text-center">我的个人信息</h5>-->
                <!--                </div>-->
                <div class="item">
                    <div class="title">用户名:</div>
                    <div class="value">
                        {{ $store.state.userData.username }}
                    </div>
                </div>
                <div class="item">
                    <div class="title">昵称:</div>
                    <div class="value">
                        {{ $store.state.userData.nickname }}
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <el-link v-access="{url:baseUrl,method:'PUT'}" v-if="$store.state.userData.username"
                                 @click="editNickname" type="primary">
                            修改
                        </el-link>
                    </div>
                </div>
                <div class="item">
                    <div class="title">手机号:</div>
                    <div class="value phone">
                        {{ $store.state.userData.phone.toString().replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2') }}&nbsp;&nbsp;&nbsp;&nbsp;
                        <el-link v-access="{url:baseUrl,method:'PUT'}" v-if="$store.state.userData.username"
                                 :disabled="phone.loading" @click="changePhone" type="primary">
                            更换
                        </el-link>
                        <span class="phone-limit-tip">每个自然年最多更换 2 次</span>
                    </div>
                </div>
                <div class="item">
                    <div class="title">微信:</div>
                    <div class="value">
                        <el-link v-access="{url:baseUrl,method:'PUT'}" v-if="$store.state.userData.unionid"
                                 @click="unBindWx" type="primary">
                            解绑
                        </el-link>
                    </div>
                </div>
                <div class="item">
                    <div class="title">密码:</div>
                    <div class="value">
                        <el-link v-access="{url:baseUrl,method:'PUT'}" v-if="$store.state.userData.username"
                                 @click="editPassword" type="primary">
                            修改
                        </el-link>
                    </div>
                </div>
                <div class="item">
                    <div @click="noUse" class="no-use">申请注销账号</div>
                </div>
            </el-col>
        </el-row>
        <no-use @change="noUsageChange" :show="no_use.show"></no-use>
        <change-phone @change="noUsageChange" :show="phone.show" :quota="phone.quota"></change-phone>
        <form-dialog :custom-class="form.customClass" @closeFormDialog="submit" :title="form.title" :show="form.show"
                     :fields="form.fields"
                     :rules="form.rules" :data="form.data">
            <template v-slot:phone="phone">

            </template>
        </form-dialog>
    </div>
</template>
<script>
import F from '@/fields/fields';
import ChangePhone from "@/components/user/profile/change-phone.vue";
import NoUse from "@/components/user/profile/no-use.vue";
import storage from "@/utils/storage";

export default {
    components: {
        NoUse, ChangePhone,
    },
    mounted() {

    },
    data() {
        return {
            baseUrl: '/bbs/user/password',
            baseProfileUrl: '/bbs/user/profile',
            baseUnWxUrl: '/bbs/user/unwx',
            baseCheckPhoneUrl: '/bbs/user/chp',
            no_use: {
                show: false,
            },
            phone: {
                show: false,
                loading: false,
                quota: null,
            },
            form: {
                actionName: '',
                customClass: '',
                show: false,
                title: '',
                data: {},
                fields: [],
                rules: {},
                index: null,
            },
        }
    },
    methods: {
        editPassword: function () {
            this.form = F.get('bbsUser', 'edit_password');
            this.form.actionName = 'editPassword';
        },
        editNickname: function () {
            let n = this.$store.state.userData.nickname;
            this.form = F.get('bbsUser', 'edit_nickname', {nickname: '', nickname_copy: n});
            this.form.customClass = 'bbs_edit_nickname';
            this.form.actionName = 'editNickname';
        },
        unBindWx: function () {
            this.$confirm('你真的要解绑微信吗?', '操作确认').then(() => {
                this.form = F.get('bbsUser', 'unbind_wx', {});
                this.form.customClass = 'unbind_wx';
                this.form.actionName = 'unBindWx';
            });
        },
        noUse() {
            this.no_use.show = true;
        },
        noUsageChange() {
            this.no_use.show = false;
            this.phone.show = false;
        },
        changePhone() {
            if (this.phone.loading) return;
            this.phone.loading = true;
            this.$bbs.get(this.baseCheckPhoneUrl, {need: {error: true, progress: true}}).then(response => {
                const quota = response.data || {};
                this.phone.quota = quota;
                if (!quota.allowed) {
                    this.$alert(quota.message, '暂时无法更换手机号', {type: 'warning'});
                    return;
                }
                this.phone.show = true;
            }).finally(() => {
                this.phone.loading = false;
            });
        },
        submit: function (data) {
            if (data.type === 'cancel') {
                this.form.show = false;
                return;
            }
            switch (this.form.actionName) {
                case 'unBindWx':
                    this.$bbs.put(this.baseUnWxUrl, data.data, {need: {error: true, progress: true}}).then(() => {
                        this.$message.success('解绑成功!');
                        this.form.show = false;
                        setTimeout(() => {
                            location.reload();
                        }, 1000);
                    });
                    break;
                case 'editPassword':
                    this.$bbs.put(this.baseUrl, data.data, {need: {error: true, progress: true}}).then(() => {
                        this.$message.success('保存成功!');
                        this.form.show = false;
                    });
                    break;
                case 'editNickname':
                    this.$bbs.put(this.baseProfileUrl, data.data, {
                        need: {
                            error: true,
                            progress: true
                        }
                    }).then((result) => {
                        this.$message.success('保存成功!');
                        let userData = storage.userData();
                        userData.nickname = result.data.nickname;
                        this.$store.dispatch('userData', userData);
                        this.form.show = false;
                    });
                    break;
            }
        }
    }
}
</script>
<style scoped lang="less">
.profile {
    margin-top: 10px;
    background: #fff;

    h5 {
        padding: 25px;
    }

    padding: 40px 0;

    .item {
        text-align: center;
        display: flex;
        margin-bottom: 20px;

        .no-use {
            width: 180px;
            cursor: pointer;
            text-align: right;
            padding-right: 10px;
            color: rgba(243, 156, 55, 0.5);
        }

        .title {
            width: 80px;
            text-align: right;
            padding-right: 10px;
            color: #666;
        }

        .value {
            text-align: left;
            padding-left: 20px;
            display: flex;
            align-items: center;
            flex: 1;
            color: #333;
        }

        .phone-limit-tip {
            margin-left: 14px;
            color: #999;
            font-size: 12px;
        }
    }
}
</style>
